export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Sin esfuerzo',
      description: 'Nos encargamos de todo: desde la publicación hasta la limpieza y atención a huéspedes.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Más ingresos',
      description: 'Optimizamos precios con IA y estrategias profesionales para maximizar tu rentabilidad.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Transparencia total',
      description: 'Ves tus resultados en tiempo real con acceso completo a estadísticas y reservas.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sin permanencia',
      description: 'Prueba sin compromiso. Si no estás satisfecho, puedes cancelar cuando quieras.'
    }
  ];

  return (
    <section className="py-24 bg-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Andrea'] text-4xl lg:text-5xl font-bold text-[#2C3E50] mb-4">
            Por qué los propietarios nos eligen
          </h2>
          <p className="font-['Satoshi'] text-lg text-gray-600 max-w-2xl mx-auto">
            Más de 200 propietarios confían en nosotros para gestionar sus propiedades vacacionales
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 shadow-sm hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#2C3E50] rounded-lg mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="font-['Andrea'] text-xl font-bold text-[#2C3E50] mb-3">
                {benefit.title}
              </h3>
              <p className="font-['Satoshi'] text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
